import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import Navbar from './components/layout/Navbar';
import Home from './pages/Home';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
// import BreakingNews from './components/sections/BreakingNews'; // Supprimé
import Contact from './pages/contact';
// import BreakingNewsBanner from './components/BreakingNewsBanner'; // Remplacé par BlogCarousel
import GeniusFramework from './pages/GeniusFramework';
import EdgeIntelligence from './pages/EdgeIntelligence';
import StradivariAppPage from './pages/StradivariApp';
import SwissAvengersSaga from './pages/SwissAvengersSaga';
import ApprentiPrep from './pages/ApprentiPrep';
import ApprentiPrepTerms from './pages/ApprentiPrepTerms';
import Hypersuit from './pages/Hypersuit';
import CloudMind from './pages/CloudMind';
import AstroDaily from './pages/AstroDaily';
import AstroDailyPrivacy from './pages/AstroDailyPrivacy';
import AstroDailyArchives from './pages/AstroDailyArchives';
import ChronoSanctuaryBlog from './pages/ChronoSanctuaryBlog';
import ClientPortal from './pages/ClientPortal';
import InfinityCloudTechDocs from './pages/InfinityCloudTechDocs';
import LiveStreamPro from './pages/LiveStreamPro';
import MusicJourney from './pages/MusicJourney';
import LaurentNuel from './pages/LaurentNuel';
import Meet from './pages/Meet';
import MeetAdmin from './pages/MeetAdmin';
import MeetDaily from './pages/MeetDaily';
import Dojo from './pages/Dojo';
import UnifiedDashboard from './pages/UnifiedDashboard';

// Import des styles
// import './styles/color-override.css'; // DÉSACTIVÉ - forçait tout en blanc avec !important
// import './styles/fix-styles.css'; // DÉSACTIVÉ - forçait tout en blanc
import './styles/apple-design.css'; 
import './styles/force-menu-fixes.css'; // Force l'application des styles pour les menus
import './styles/temp-icons.css'; // Icônes temporaires pour la section Impact
import './styles/chronosanctuary-blog.css'; // Styles mystiques ChronoSanctuary
import './styles/presentation-design-system.css'; // Design system des tuiles de présentation
import './styles/animations.css'; // Animations CSS

function AppContent() {
  const location = useLocation();
  
  // Vérifie si on est dans le portail client ou la page consultant
  const isPortalClient = location.pathname.startsWith('/portail-client');
  const isConsultantPage = location.pathname.startsWith('/consultant');
  // V1.0 LOBBY : /meet est une app fullscreen — pas de navbar marketing
  const isMeetPage = location.pathname.startsWith('/meet') || location.pathname === '/dojo';
  
  return (
    <div className="min-h-screen">
      {/* N'affiche la bannière et la navbar que si on n'est pas dans le portail client ou consultant */}
      {/* Bannière défilante supprimée - remplacée par BlogCarousel sur la page d'accueil */}
      {/* BreakingNews supprimé complètement */}
      {!isPortalClient && !isConsultantPage && !isMeetPage && <Navbar />}
      {/* Padding-top supprimé car plus de bannière fixe */}
      <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/astrodaily" element={<AstroDaily />} />
          <Route path="/astrodaily/privacy" element={<AstroDailyPrivacy />} />
          <Route path="/astrodaily/archives" element={<AstroDailyArchives />} />
          <Route path="/chronosanctuary" element={<ChronoSanctuaryBlog />} />
          <Route path="/GeniusFramework" element={<GeniusFramework />} />
          <Route path="/EdgeIntelligence" element={<EdgeIntelligence />} />
          <Route path="/StradivariApp" element={<StradivariAppPage />} />
          <Route path="/swiss-avengers-saga" element={<SwissAvengersSaga />} />
          <Route path="/apprentiprep" element={<ApprentiPrep />} />
          <Route path="/apprentiprep/terms" element={<ApprentiPrepTerms />} />
          <Route path="/hypersuit" element={<Hypersuit />} />
          <Route path="/cloudmind" element={<CloudMind />} />
          <Route path="/portail-client" element={<ClientPortal />} />
          {/* Route générique pour les clients */}
          <Route path="/portail-client/:clientId" element={<UnifiedDashboard />} />
          
          {/* Live TV/Podcast - RESTAURÉ */}
          <Route path="/live" element={<LiveStreamPro />} />
          
          {/* Music Journey - Parcours musical avec AI */}
          <Route path="/music" element={<MusicJourney />} />

          {/* Meet - Conférence vidéo avec LiveKit (self-hosted) */}
          <Route path="/meet" element={<Meet />} />
          <Route path="/meet/admin" element={<MeetAdmin />} />
          <Route path="/dojo" element={<Dojo />} />

          {/* Laurent Nuel - Consultant page privée (pas dans la navigation) */}
          <Route path="/consultant/laurent" element={<LaurentNuel />} />
          
          {/* Redirections temporaires pour la transition de news à blog */}
          <Route path="/news" element={<Navigate to="/blog" replace />} />
          <Route path="/news/:slug" element={<Navigate to="/blog/:slug" replace />} />
        </Routes>
      </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
        <Toaster position="top-right" />
      </Router>
    </AuthProvider>
  );
}

export default App;
